// Use Webpack's require.context to get all files in the images folder
const t2aImageContext = require.context('../../../../img/app/Vieutopia Styles', false, /\.(jpg|jpeg|png|gif)$/);

// Create an array of all imported image file paths
export const t2aImagePaths = t2aImageContext.keys().map(t2aImageContext);

const i2iImageContext = require.context('../../../../img/app/i2i/styles',false,/\.(jpg|jpeg|png|webp)$/);

export const i2iImagePaths = i2iImageContext.keys().map(i2iImageContext);